module.exports = __webpack_public_path__ + "static/media/warningIcon.7a55a07c.svg";